import React, { forwardRef } from 'react';
import {
  FieldProps,
  InjectedFieldProps,
  useDataProvider,
  useNotify,
  useRefresh,
} from 'react-admin';
import MenuItem from '@material-ui/core/MenuItem';

import { Confirmation } from 'components/common';
import { RewardBenefitDto } from '../../types';

type DeleteRewardBenefitFieldProps = (FieldProps & InjectedFieldProps) & {
  record?: RewardBenefitDto;
};

const DeleteRewardBenefitField = forwardRef<HTMLLIElement, DeleteRewardBenefitFieldProps>(
  ({ record }, ref) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();

    const handleDeleteBenefit = async () => {
      if (!record?.id) {
        return;
      }

      try {
        await dataProvider.delete('rewardsBenefit', { id: record.id });
        refresh();
      } catch (error: unknown) {
        const message = error instanceof Error ? error.message : 'Failed to delete rewards benefit';
        notify(message);
      }
    };

    return (
      <Confirmation title="Delete benefit" content="Are you sure you want to delete this benefit?">
        <MenuItem ref={ref} onClick={handleDeleteBenefit}>
          Delete
        </MenuItem>
      </Confirmation>
    );
  }
);

export default DeleteRewardBenefitField;
